/* global G */
import { curry, setKey } from 'lib/util'
import validate from 'lib/sequence/model/validate'
import { back, redirect } from 'app/_shared/events'
import { v4 as uuidV4 } from 'uuid'
import refresh from 'lib/sequence/model/api/refresh'

/**
 * Redirects or goes back based on the route we're coming from
 *
 * @param {Gaia.AppModule.Spec} module - app module
 * @param {Gaia.Component.Spec} component - action component
 * @param {Gaia.PlatformEvent} event - event
 * @returns {*|(function(...[*]): (*))}
 * @private
 */
const _redirectOrBack = (module, component, event) => {
  const history = module[G.ADAPTER][G.SESSION][G.STATE][G.PREV]
  const lastEntry = history[history.length - 1]

  // If we come from the device creation wizard we need to go back because
  // we already have serviceItem::create in the history
  if (lastEntry[G.MODULE] === 'serviceItem' && lastEntry[G.ACTION] === 'create') {
    return back(module, component, event)
  }

  return redirect(module, component, event)
}

/**
 * Event Handler Model Attribute Add.
 *
 * Adds or modifies a new or existing object sub-model to the base model.
 *
 * @param {string} name                       the name of the child model
 * @param {boolean} [redirectOnSuccess=true]  whether {@link redirect} should be executed on success
 * @returns {Gaia.AppModule.EventHandler}
 */
const save = (name, redirectOnSuccess = true) => curry(async (module, component, event) => {
  const model = module[G.MODEL]
  const child = model[G.CHILDREN][name]
  const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]

  setKey(false, G.ERROR, module[G.STATE])
  const ref = child[G.STATE][G.REF]
  // modelReset(child)
  // validate model against component's fields
  await validate(child)(actionComponent)
  // set submodel error as main model error
  // moduleState[G.ERROR] = child[G.STATE][G.ERROR]

  if (!child[G.STATE][G.ERROR]) {
    // refresh model's cache from its own data
    await refresh(child)
    // set deductible fields
    child[G.STATE][G.REF] = ref || uuidV4()
    child[G.STATE][G.BULK] = true
    child[G.DATA].status = 50
    // removing action's dirty flag
    setKey(false, G.UNDO, module[G.STATE][G.ACTION][G.STATE])
    // redirect to component's route
    redirectOnSuccess && await _redirectOrBack(module, component, event)
  } else {
    setKey(true, G.ERROR, module[G.STATE])
    module[G.ADAPTER][G.UI].update(module)
    // await actionWithHooks(module[G.STATE][G.ACTION])([])
  }
})

export default save
